<template>
    <section>
        <b-modal v-model="opened" :title="getTitle()" ref="modal" id="modal-demo">
            <div class="edit-valve">
                <label class="name-field">
                    <span>{{$t('message.name')}}</span>
                    <input type="text" v-model="name" class="form-control">
                </label>

                <div class="section-title">
                    <b>{{$t('message.close_water_automatically')}}</b>:
                </div>

                <div class="settings-box">
                    <div class="settings-row">
                        <toggle-button v-model="continuousWaterConsumptionLimitTgl" :sync="true" :labels="true"/>
                        <div class="settings-rule">
                            <span>{{$t('message.when_continuous_consumption_exceeds')}}</span>
                            <input type="number" v-model="continuousWaterConsumptionLimit" @change="update('continuousWaterConsumptionLimit')" class="form-control number-input">
                            <span>{{$t('message.liters_after_number')}}</span>
                        </div>
                    </div>
                    <span class="example">{{$t('message.example')}}: {{$t('message.continuous_consumption_example')}}</span>
                </div>

                <div class="settings-box">
                    <div class="settings-row">
                        <toggle-button v-model="drippingLimitTgl" :sync="true" :labels="true"/>
                        <div class="settings-rule">
                            <input type="number" v-model="drippingLimit" @change="update('drippingLimit', 255)" class="form-control number-input">
                            <span>{{$t('message.consecutive_hours_with_any_consumption')}}</span>
                        </div>
                    </div>
                    <span class="example">{{$t('message.example')}}: {{$t('message.dripping_example')}}</span>
                </div>

                <div class="settings-box">
                    <div class="settings-row">
                        <toggle-button v-model="consumptionInTimeLimitTgl" :sync="true" :labels="true"/>
                        <div class="settings-rule">
                            <span>{{$t('message.when_the_total_consumption')}}</span>
                            <input type="number" v-model="consumptionInTimeLimitConsumption" @change="update('consumptionInTimeLimitConsumption')" class="form-control number-input">
                            <span>{{$t('message.liters_in')}}</span>
                            <input type="number" v-model="consumptionInTimeLimitTime" @change="update('consumptionInTimeLimitTime')" class="form-control number-input">
                            <span>{{$t('message.minutes')}}</span>
                        </div>
                    </div>
                    <span class="example">{{$t('message.example')}}: {{$t('message.total_consumption_example')}}</span>
                </div>

                <div class="settings-box">
                    <div class="settings-row">
                        <toggle-button v-model="currentFlowLimitTgl" :sync="true" :labels="true"/>
                        <div class="settings-rule">
                            <span>{{$t('message.when_the_current_flow')}}</span>
                            <input type="number" step="0.1" v-model="currentFlowLimit" @change="update('currentFlowLimit', 25.5)" class="form-control number-input">
                            <span>{{$t('message.liters_per_second')}}</span>
                            <button v-if="maximum === ''" class="btn btn-default btn-sm check-max-btn" type="button" @click="checkMaximum">
                                <i v-if="loading" class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                                {{$t('message.check_maximum')}}
                            </button>
                            <span class="maximum" v-if="maximum !== ''">{{maximum}}</span>
                        </div>
                    </div>
                    <span class="example">{{$t('message.example')}}: {{$t('message.current_flow_example')}}</span>
                </div>

                <div class="section-title">
                    <b>{{$t('message.valve_email_warning')}}</b>
                    <span class="section-note">{{$t('message.internet_required')}}</span>
                </div>
                <div class="email-locked">
                    {{$t('message.valve_email_warning_2')}}
                </div>
                <div class="settings-box subscribers-box">
                    <ul class="subscribers-list" v-if="subscribers.length">
                        <li v-for="sub of subscribers" :key="sub.email">
                            <span>{{sub.email}}</span>
                            <button
                                v-if="sub.deletable"
                                type="button"
                                class="btn btn-danger btn-xs"
                                @click="deleteSubscriber(sub.email)"
                            >
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                        </li>
                    </ul>
                    <div class="email-add">
                        <input v-model="email" type="text" class="form-control" placeholder="email">
                        <button class="btn btn-default" @click="addSubscriber" type="button">{{$t('message.add')}}</button>
                    </div>
                </div>
            </div>
            <template #footer>
                <b-btn @click="close">{{$t('message.cancel')}}</b-btn>
                <b-btn @click="validate" type="primary">{{$t('message.save')}}</b-btn>
            </template>
        </b-modal>
    </section>
</template>

<script>
    import storage, {VALVE_ALARM_REQUEST, VALVE_REQUEST} from '../../../_store'
    import mixins from '../../../modules/mixins'
    import moment from 'moment'

    export default {
        name: 'EditValve',
        mixins: [mixins],
        data () {
            return {
                opened: false,
                valve: null,
                sensor: null,
                homebase: null,
                action: null,
                name: '',
                currentFlowLimit: 0,
                currentFlowLimitTgl: false,
                continuousWaterConsumptionLimit: 0,
                continuousWaterConsumptionLimitTgl: false,
                drippingLimit: 0,
                drippingLimitTgl: false,
                consumptionInTimeLimitTime: 0,
                consumptionInTimeLimitConsumption: 0,
                consumptionInTimeLimitTgl: false,
                maximum: '',
                loading: false,
                subscribers: [],
                email: ''
            }
        },
        methods: {
            getTitle () {
                return this.$t('message.valve') + ' ' + this.valve.serialNumber
            },
            validate () {
                if (!this.name || this.name === '') {
                    this.name = this.valve.serialNumber
                }
                if (this.currentFlowLimitTgl && !this.isFloat(this.currentFlowLimit)) {
                    this.notify('danger', this.$t('message.invalid_number'))
                    return
                }

                if (this.continuousWaterConsumptionLimitTgl && !this.isInteger(this.continuousWaterConsumptionLimit)) {
                    this.notify('danger', this.$t('message.invalid_number'))
                    return
                }

                if (this.drippingLimitTgl && !this.isInteger(this.drippingLimit)) {
                    this.notify('danger', this.$t('message.invalid_number'))
                    return
                }

                if (this.consumptionInTimeLimitTgl && (!this.isInteger(this.consumptionInTimeLimitConsumption) || !this.isInteger(this.consumptionInTimeLimitTime))) {
                    this.notify('danger', this.$t('message.invalid_number'))
                    return
                }

                const data = {
                    vid: this.valve.id,
                    sensor: this.sensor,
                    homebase: this.homebase,
                    action: this.action,
                    name: this.name,
                    currentFlowLimit: this.currentFlowLimitTgl ? Math.floor(this.currentFlowLimit * 10) : 0,
                    continuousWaterConsumptionLimit: this.continuousWaterConsumptionLimitTgl ? this.continuousWaterConsumptionLimit : 0,
                    drippingLimit: this.drippingLimitTgl ? this.drippingLimit : 0,
                    consumptionInTimeLimitTime: this.consumptionInTimeLimitTgl ? this.consumptionInTimeLimitTime : 0,
                    consumptionInTimeLimitConsumption: this.consumptionInTimeLimitTgl ? this.consumptionInTimeLimitConsumption : 0
                }
                this.valve.saving = true
                storage.dispatch(VALVE_REQUEST, data)
                    .then(response => {
                        this.valve.saving = false
                        if (response.data.result) {
                            this.valve.name = this.name
                            this.close()
                            this.notify('info', response.data.message)
                        } else {
                            this.notify({
                                content: response.data.message,
                                duration: 10
                            })
                        }
                    })
                    .catch(err => {
                        this.valve.saving = false
                        if (err.response) {
                            this.notify('danger', err.response.data.message)
                        } else {
                            this.notify('danger', err.message)
                        }
                    })
            },
            show (item) {
                this.maximum = ''
                this.loading = false
                this.open()
                // todo optimize
                this.valve = item
                this.action = 'edit'
                this.homebase = item.homebase
                this.sensor = item.serialNumber
                this.name = item.name
                this.currentFlowLimit = item.currentFlowLimit / 10
                this.currentFlowLimitTgl = item.currentFlowLimit > 0

                this.continuousWaterConsumptionLimit = item.continuousWaterConsumptionLimit
                this.continuousWaterConsumptionLimitTgl = item.continuousWaterConsumptionLimit > 0

                this.drippingLimit = item.drippingLimit
                this.drippingLimitTgl = item.drippingLimit > 0

                this.consumptionInTimeLimitTime = item.consumptionInTimeLimitTime
                this.consumptionInTimeLimitConsumption = item.consumptionInTimeLimitConsumption
                this.consumptionInTimeLimitTgl = item.consumptionInTimeLimitTime > 0 && item.consumptionInTimeLimitConsumption > 0
            },
            isInteger (input) {
                return /^[0-9]+$/.test(input)
            },
            isFloat (input) {
                return /^[0-9]+(\.[0-9]+)?$/.test(input)
            },
            update (name, max = 65535) {
                let tglName = name.replace(/Time$|Consumption$|$/i, 'Tgl')
                if (/^0$/.test(this[name])) {
                    this[tglName] = false
                } else if (this[name] > max) {
                    this[name] = max
                    this[tglName] = true
                } else if (this[name] > 0) {
                    this[tglName] = true
                } else if (this[name] < 0) {
                    this[name] = 0
                    this[tglName] = false
                }
            },
            open () {
                this.opened = true
                this.$emit('open')
            },
            close () {
                this.opened = false
                this.$emit('close')
            },
            checkMaximum () {
                this.loading = true
                storage.dispatch(VALVE_REQUEST, {type: 'max', transmitter: this.sensor})
                  .then(resp => {
                      this.loading = false
                      let value = Math.round((resp.data.data.max) / 36000) * 10
                      if (value < 1) {
                          value = this.$t('message.less_then') + ' 1'
                      }
                      const date = moment(resp.data.data.datetime)
                      this.maximum = this.$t('message.maximum_until_now') + ': ' + value + ' ' + this.$t('message.liters_per_second') + '  (' + date.format('LLL') + ')'
                  }).catch(err => {
                      this.loading = false
                      this.$b_notify({
                          type: 'danger',
                          content: err
                      })
                  })
            },
            getListOfSubscribers () {
                storage.dispatch(VALVE_ALARM_REQUEST)
                    .then(resp => {
                        this.subscribers = resp.data.data.map(x => {
                            return {
                                email: x,
                                deletable: true
                            }
                        })
                        this.subscribers[0].deletable = false
                    }).catch(err => {
                        this.notify('danger', this.getErrorMessage(err))
                    })
            },
            addSubscriber () {
                storage.dispatch(VALVE_ALARM_REQUEST, {
                    action: 'add',
                    email: this.email
                })
                    .then(resp => {
                        this.getListOfSubscribers()
                    }).catch(err => {
                        this.$b_notify({
                            type: 'danger',
                            content: err
                        })
                    })
            },
            deleteSubscriber (email) {
                storage.dispatch(VALVE_ALARM_REQUEST, {
                    action: 'delete',
                    email
                })
                    .then(resp => {
                        this.getListOfSubscribers()
                    }).catch(err => {
                        this.$b_notify({
                            type: 'danger',
                            content: err
                        })
                    })
            }
        },
        created () {
            this.getListOfSubscribers()
        }
    }
</script>

<style scoped>
  .edit-valve {
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
  }
  .name-field {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    margin: 0;
    font-weight: 500;
  }
  .section-title {
    margin-top: 0.35rem;
  }
  .section-note {
    display: block;
    margin-top: 0.15rem;
    color: #737373;
    font-size: 0.9em;
    font-weight: normal;
  }
  .settings-box {
    padding: 0.65rem 0;
    border-top: 1px solid #e8e8e8;
  }
  .settings-row {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
  }
  .settings-rule {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.35rem 0.45rem;
    line-height: 1.45;
  }
  .number-input.form-control {
    display: inline-block;
    width: 4.75rem;
    min-width: 4.75rem;
    max-width: 4.75rem;
    height: 2rem;
    padding: 0.2rem 0.45rem;
    flex: 0 0 auto;
  }
  .check-max-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    white-space: nowrap;
  }
  .maximum {
    font-weight: 600;
  }
  .example {
    display: block;
    margin: 0.4rem 0 0 3.75rem;
    color: #737373;
    font-size: 85%;
  }
  .email-locked {
    color: #374151;
    font-size: 0.95em;
  }
  .subscribers-box {
    border-top: 1px solid #e8e8e8;
    padding-top: 0.75rem;
  }
  .subscribers-list {
    list-style: none;
    margin: 0 0 0.75rem;
    padding: 0;
  }
  .subscribers-list li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 0.25rem 0;
  }
  .email-add {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }
  .email-add .form-control {
    flex: 1;
    min-width: 0;
  }
  @media (max-width: 576px) {
    .example {
      margin-left: 0;
    }
  }
</style>
